import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Iframe from 'react-iframe'

const styles = {
 
    card2: {
        alignItems:'center',
        align: 'center',
        boxShadow: 'none',
        border:'none',
        // height:'100%',
        // width:'100vw',
        // minHeight: 700,
        // minWidth: 725,
        marginLeft:'auto',
        marginRight: 'auto'
    },
    myClassname:{

    }
  };

class ChatBoxMobile extends Component {

    state={
        height:'30vh',
        width:'30vw'
    };

    componentDidMount(){
        setInterval(()=>{
            this.setState({
                height:'100vh',
                width:'100vw'
            })
        },3000)
    }

    render(){
        const { classes, src } = this.props; 
        let fileURL = "";
        if (localStorage.getItem('language') == "en"){
            fileURL = __dirname + 'chatbotAmendment.html?caseId='+this.props.caseId
        }
        else if (localStorage.getItem('language') == "cn"){
            fileURL = __dirname + 'chatbotAmendmentChi.html?caseId='+this.props.caseId
        }
        
        return(
            <div style={{height:this.state.height, width:this.state.width}}>
                <Iframe url={fileURL}
                    position="relative"
                    width="100%"
                    height="90%"
                    // height="100%"
                    id="myId"
                    className="myClassname"
                    />
            </div>
        );
    }
}

export default withStyles(styles)(ChatBoxMobile);